import { IContext } from '@components-member/TradingAccounts/AccountCreate/interfaces';
import { IModalFormField } from '@components-member/socialTrading/social.interfaces';
import generator from 'components/shared/forms/formGenerator';

export const formProvider = (fields: IModalFormField[]) => {
  return generator(fields, {
    type: (ctx: IContext, value: number): void => {
      const { typeTrigger } = ctx.props;

      if (typeTrigger) {
        typeTrigger(value);
      }
    },
  });
};
